var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { SquirtleSquadApiClient } from '@madbox/squirtle_squad_api_client';
import createSagaMiddleware from '@redux-saga/core';
import { configureStore } from '@reduxjs/toolkit';
import { createBrowserHistory } from 'history';
import { combineReducers } from 'redux';
import { all } from 'redux-saga/effects';
import { initRequest, reducer as sessionReducer, saga as sessionSaga } from '@madbox/react_session_manager';
import { reducer as memberReducer, saga as memberSaga } from '@madbox/react_member_manager';
import { reducer as snackbar } from '@madbox/react_redux_request_handling';
import { QueryClient } from 'react-query';
import { insertGtagScript } from './gtag';
export var isDevEnv = process.env.NODE_ENV !== 'production';
var defaultQueryClientOptions = {
    queries: {
        retry: false,
        refetchOnWindowFocus: false,
        refetchOnMount: false,
        refetchOnReconnect: false,
        cacheTime: 0, // by default we do now cache queries because we want to have everything fresh
    },
};
/**
 * Inits redux store and react-router's history
 *
 * Return values should be passed to {@link MadboxTemplate} props
 *
 * @param props reducers and sagas
 * @returns
 */
export function init(props) {
    var _a, _b, _c;
    if (props === void 0) { props = {}; }
    var reducersMap = props.reducersMap, sagas = props.sagas, preloadedState = props.preloadedState, customGetProfile = props.customGetProfile, customGetMenu = props.customGetMenu;
    SquirtleSquadApiClient.init(props.squirtleSquadConfig);
    var history = createBrowserHistory({ basename: '#' });
    if (props.useAnalytics || (props.useAnalytics === undefined && !isDevEnv)) {
        insertGtagScript(history);
    }
    var sagaMiddleware = createSagaMiddleware();
    var reducer = combineReducers(__assign({ session: sessionReducer, member: memberReducer, snackbar: snackbar }, reducersMap));
    var store = configureStore({
        reducer: reducer,
        middleware: function (getDefaultMiddleware) {
            return getDefaultMiddleware({
                immutableCheck: true,
                serializableCheck: true,
                thunk: false,
            }).concat(sagaMiddleware);
        },
        devTools: isDevEnv,
        preloadedState: preloadedState,
    });
    sagaMiddleware.run(function rootSaga() {
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, all([sessionSaga(), memberSaga()].concat(sagas))];
                case 1:
                    _a.sent();
                    return [2 /*return*/];
            }
        });
    });
    store.dispatch(initRequest({
        customGetProfile: customGetProfile,
        customGetMenu: customGetMenu,
    }));
    var queryClient = new QueryClient(__assign(__assign({}, props.queryClientConfig), { defaultOptions: __assign(__assign(__assign({}, defaultQueryClientOptions), (_a = props.queryClientConfig) === null || _a === void 0 ? void 0 : _a.defaultOptions), { queries: __assign(__assign({}, defaultQueryClientOptions.queries), (_c = (_b = props.queryClientConfig) === null || _b === void 0 ? void 0 : _b.defaultOptions) === null || _c === void 0 ? void 0 : _c.queries) }) }));
    return { history: history, store: store, queryClient: queryClient };
}
